import styled from 'styled-components'

import { helpers } from 'styles'

export const TopWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: ${helpers.color.pageHeader};
	width: 100%;
	height: 48px;
	top: 0;
	position: fixed;
	z-index: 9;
`
